(function () {
  /* =========================
     共通設定
     ========================= */
  const SCOPE_ID = 'shopify-section-template--26446847508664__17678594792f8026ea';
  const STYLE_ERR = `
    color: rgb(212, 60, 60);
    font-size: 13px;
    margin-top: 6px;
    line-height: 1.4;
  `;

  const MSG = {
    name: 'お名前を入力してください',
    email: 'メールアドレスを正しく入力してください',
    emailConfirm: '確認用メールアドレスを正しく入力してください',
    emailMismatch: 'メールアドレスが一致しません。入力を確認してください。',
    message: 'お問い合わせ内容を入力してください',
    privacy: '同意してください',
  };

  const scope = () =>
    document.getElementById(SCOPE_ID) ||
    document.getElementById('wizard-validation-form') ||
    document;

  const byId = (id) => document.getElementById(id);
  const emailValid = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((v || '').trim());

  const getForm = () => {
    const root = scope();
    return (
      root.querySelector('#formGeneratorForm') ||
      document.querySelector('#formGeneratorForm')
    );
  };

  /* =========================
     ★追加：お問い合わせ項目 select のフォントを強制的に 16px にする
     - extra-styles.css の 12px !important に勝つため、style属性に !important を付与
     ========================= */
  const forceItemSelectFont = () => {
    const root = scope();
    const sel = byId('hf-item') || root.querySelector('#hf-item');
    if (!sel) return;

    // style属性にimportantで入れる（外部CSSの!importantより強い）
    sel.style.setProperty('font-size', '16px', 'important');
    sel.style.setProperty('line-height', '1.4', 'important');

    // ドロップダウン内部(option)はOS描画の都合で効かない場合がありますが、一応入れる
    try {
      sel.querySelectorAll('option').forEach((opt) => {
        opt.style.setProperty('font-size', '16px', 'important');
      });
    } catch (_) {}
  };

  /* =========================
     エラー表示ヘルパー（input/textarea用）
     ========================= */
  const ensureErrorEl = (field, key) => {
    if (!field) return null;

    const next = field.nextElementSibling;
    if (
      next &&
      next.classList &&
      next.classList.contains('js-hulk-field-error') &&
      next.getAttribute('data-for') === key
    ) {
      return next;
    }

    const el = document.createElement('div');
    el.className = 'js-hulk-field-error';
    el.setAttribute('data-for', key);
    el.style.cssText = STYLE_ERR;
    el.hidden = true;
    field.insertAdjacentElement('afterend', el);
    return el;
  };

  const showErr = (field, key, text) => {
    const el = ensureErrorEl(field, key);
    if (!el) return;
    el.textContent = text;
    el.hidden = false;
  };

  const hideErr = (field, key) => {
    const el = ensureErrorEl(field, key);
    if (!el) return;
    el.hidden = true;
  };

  /* =========================
     エラー表示ヘルパー（checkbox用）
     - p.infoMessage の「上」に出す（既存が下にあっても上へ移動）
     ========================= */
  const ensureWrapErrorEl = (wrap, key) => {
    if (!wrap) return null;

    const pInfo = wrap.querySelector('p.infoMessage');

    let el = wrap.querySelector(`.js-hulk-field-error[data-for="${key}"]`);
    if (!el) {
      el = document.createElement('div');
      el.className = 'js-hulk-field-error';
      el.setAttribute('data-for', key);
      el.style.cssText = STYLE_ERR;
      el.hidden = true;

      if (pInfo && pInfo.parentNode === wrap) {
        wrap.insertBefore(el, pInfo);
      } else {
        wrap.appendChild(el);
      }
      return el;
    }

    if (pInfo && pInfo.parentNode === wrap) {
      const pos = el.compareDocumentPosition(pInfo);
      const elIsAfterP = !!(pos & Node.DOCUMENT_POSITION_PRECEDING);
      if (elIsAfterP) {
        wrap.insertBefore(el, pInfo);
      }
    }

    return el;
  };

  const showWrapErr = (wrap, key, text) => {
    const el = ensureWrapErrorEl(wrap, key);
    if (!el) return;
    el.textContent = text;
    el.hidden = false;
  };

  const hideWrapErr = (wrap, key) => {
    const el = ensureWrapErrorEl(wrap, key);
    if (!el) return;
    el.hidden = true;
  };

  /* =========================
     必須 * を赤くする（既存のみ）
     ========================= */
  const paintAsterisk = () => {
    const root = scope();
    root.querySelectorAll('.form-group > label').forEach((label) => {
      if (label.querySelector('.required-asterisk')) return;
      const html = label.innerHTML;
      if (!html || !html.trim().endsWith('*')) return;

      label.innerHTML = html.replace(
        /\*$/,
        '<span class="required-asterisk" style="color:#ff0000">*</span>'
      );
    });
  };

  /* =========================
     プライバシー本文(p.infoMessage)に改行を入れる
     ========================= */
  const formatPrivacyInfoMessage = () => {
    const root = scope();
    const p = root.querySelector('.terms_conditions p.infoMessage');
    if (!p) return;

    if (p.dataset.brApplied === '1') return;

    const raw = String(p.textContent || '').replace(/\r\n/g, '\n');
    if (!raw.includes('\n')) {
      p.dataset.brApplied = '1';
      return;
    }

    const html = raw
      .trim()
      .replace(/\n\s*\n+/g, '<br><br>')
      .replace(/\n/g, '<br>');

    p.innerHTML = html;
    p.dataset.brApplied = '1';
  };

  /* =========================
     プライバシー通知の末尾 * を消す（terms_conditions内のみ）
     ========================= */
  const removePrivacyAsterisk = () => {
    const root = scope();
    root.querySelectorAll('.terms_conditions label').forEach((label) => {
      const html = label.innerHTML || '';
      const trimmed = html.trim();

      if (trimmed.endsWith('*')) {
        label.innerHTML = html.replace(/\*\s*$/, '');
        return;
      }

      const removed = html.replace(
        /<span[^>]*class="required-asterisk"[^>]*>\*<\/span>\s*$/i,
        ''
      );
      if (removed !== html) label.innerHTML = removed;
    });
  };

  /* =========================
     ★重要：お問い合わせ内容 textarea（現状維持）
     ========================= */
  const enableTextareaResize = () => {
    const root = scope();
    const ta = byId('hf-message') || root.querySelector('#hf-message');
    if (!ta) return;

    const h = Math.round(ta.getBoundingClientRect().height || 0);
    if (h < 94) {
      ta.style.height = '94px';
    }

    ta.style.minHeight = '94px';
    ta.style.maxHeight = 'none';
    ta.style.padding = '12px';
    ta.style.resize = 'vertical';
    ta.style.overflow = 'auto';
    ta.style.boxSizing = 'border-box';

    const wrap =
      ta.closest('.formElement_6') ||
      ta.closest('.form-group') ||
      ta.parentElement;

    if (wrap) {
      wrap.style.height = 'auto';
      wrap.style.maxHeight = 'none';
      wrap.style.overflow = 'visible';
    }

    const row = ta.closest('.row.form_container') || ta.closest('.form_container');
    if (row) {
      row.style.height = 'auto';
      row.style.maxHeight = 'none';
      row.style.overflow = 'visible';
    }
  };

  /* =========================
     名前 / メッセージ（現状維持）
     ========================= */
  const bindName = () => {
    const input = byId('hf-name');
    if (!input || input.dataset.boundName === '1') return;
    input.dataset.boundName = '1';

    hideErr(input, 'name');

    const check = () => {
      if ((input.value || '').trim() === '') showErr(input, 'name', MSG.name);
      else hideErr(input, 'name');
    };

    input.addEventListener('input', () => hideErr(input, 'name'));
    input.addEventListener('blur', check);
  };

  const bindMessage = () => {
    const ta = byId('hf-message');
    if (!ta || ta.dataset.boundMsg === '1') return;
    ta.dataset.boundMsg = '1';

    hideErr(ta, 'message');

    const check = () => {
      if ((ta.value || '').trim() === '') showErr(ta, 'message', MSG.message);
      else hideErr(ta, 'message');
    };

    ta.addEventListener('input', () => hideErr(ta, 'message'));
    ta.addEventListener('blur', check);
  };

  /* =========================
     メール / 確認（現状維持）
     ========================= */
  const bindEmail = () => {
    const email = byId('hf-email');
    const confirm = byId('hf-email-confirm');
    if (!email || !confirm || email.dataset.boundEmail === '1') return;
    email.dataset.boundEmail = '1';

    const validate = () => {
      const v1 = (email.value || '').trim();
      const v2 = (confirm.value || '').trim();

      hideErr(email, 'email');
      hideErr(confirm, 'confirm');

      if (v1 === '' || !emailValid(v1)) {
        showErr(email, 'email', MSG.email);
        if (v2 !== '') showErr(confirm, 'confirm', MSG.emailConfirm);
        return;
      }

      if (v2 === '') {
        showErr(confirm, 'confirm', MSG.emailConfirm);
        return;
      }

      if (!emailValid(v2)) {
        showErr(confirm, 'confirm', MSG.emailConfirm);
        return;
      }

      if (v1 !== v2) {
        showErr(email, 'email', MSG.emailMismatch);
      }
    };

    email.addEventListener('blur', validate);
    confirm.addEventListener('blur', validate);
    email.addEventListener('input', () => hideErr(email, 'email'));
    confirm.addEventListener('input', () => hideErr(confirm, 'confirm'));
  };

  /* =========================
     セレクト（Please Select除去）（現状維持）
     ========================= */
  const bindItemSelect = () => {
    const sel = byId('hf-item');
    if (!sel || sel.dataset.boundItem === '1') return;
    sel.dataset.boundItem = '1';

    const apply = () => {
      if (!sel.options || !sel.options.length) return;
      const first = sel.options[0];
      const t = (first.textContent || '').trim().toLowerCase();
      const v = (first.value || '').trim();

      if (t.includes('please select') || v === '') {
        sel.remove(0);
      }

      // ★毎回フォントも強制（後から上書きされても戻す）
      forceItemSelectFont();
    };

    apply();
    setTimeout(apply, 300);
    setTimeout(apply, 900);
    setTimeout(apply, 1800);

    // change時も保険で強制
    sel.addEventListener('change', () => forceItemSelectFont());
    sel.addEventListener('focus', () => forceItemSelectFont());
  };

  /* =========================
     同意チェック（changeで消す）
     ========================= */
  const bindPrivacy = () => {
    const root = scope();
    const form = getForm();
    if (!form) return;

    const wrap = root.querySelector('.terms_conditions');
    const chk = root.querySelector('.terms_conditions input[type="checkbox"]');
    if (!wrap || !chk || chk.dataset.boundPrivacy === '1') return;
    chk.dataset.boundPrivacy = '1';

    hideWrapErr(wrap, 'privacy');

    chk.addEventListener('change', () => {
      if (chk.checked) hideWrapErr(wrap, 'privacy');
    });
  };

  /* =========================
     送信時バリデーション（submit + click）
     ========================= */
  const validateOnSend = () => {
    const root = scope();

    const name = byId('hf-name');
    const msg = byId('hf-message');
    const email = byId('hf-email');
    const confirm = byId('hf-email-confirm');

    const termsWrap = root.querySelector('.terms_conditions');
    const termsChk = root.querySelector('.terms_conditions input[type="checkbox"]');

    let ok = true;
    let first = null;

    if (name) {
      if ((name.value || '').trim() === '') {
        showErr(name, 'name', MSG.name);
        ok = false;
        first = first || name;
      } else {
        hideErr(name, 'name');
      }
    }

    if (msg) {
      if ((msg.value || '').trim() === '') {
        showErr(msg, 'message', MSG.message);
        ok = false;
        first = first || msg;
      } else {
        hideErr(msg, 'message');
      }
    }

    if (email && confirm) {
      const v1 = (email.value || '').trim();
      const v2 = (confirm.value || '').trim();

      hideErr(email, 'email');
      hideErr(confirm, 'confirm');

      if (v1 === '' || !emailValid(v1)) {
        showErr(email, 'email', MSG.email);
        ok = false;
        first = first || email;

        if (v2 === '' || !emailValid(v2)) {
          showErr(confirm, 'confirm', MSG.emailConfirm);
          first = first || confirm;
        }
      } else {
        if (v2 === '') {
          showErr(confirm, 'confirm', MSG.emailConfirm);
          ok = false;
          first = first || confirm;
        } else if (!emailValid(v2)) {
          showErr(confirm, 'confirm', MSG.emailConfirm);
          ok = false;
          first = first || confirm;
        } else if (v1 !== v2) {
          showErr(email, 'email', MSG.emailMismatch);
          ok = false;
          first = first || email;
        }
      }
    }

    if (termsWrap && termsChk) {
      if (!termsChk.checked) {
        showWrapErr(termsWrap, 'privacy', MSG.privacy);
        ok = false;
        first = first || termsChk;
      } else {
        hideWrapErr(termsWrap, 'privacy');
      }
    }

    if (!ok && first && typeof first.scrollIntoView === 'function') {
      first.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => {
        try {
          first.focus({ preventScroll: true });
        } catch (_) {
          try { first.focus(); } catch (__) {}
        }
      }, 50);
    }

    return ok;
  };

  const bindSubmitValidation = () => {
    const root = scope();
    const form = getForm();
    if (!form || form.dataset.boundSubmit === '1') return;
    form.dataset.boundSubmit = '1';

    form.addEventListener(
      'submit',
      (e) => {
        const ok = validateOnSend();
        if (!ok) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );

    const btn =
      root.querySelector('.form_submit_div button[type="submit"]') ||
      root.querySelector('.form_submit_div button') ||
      form.querySelector('button[type="submit"]');

    if (btn && btn.dataset.boundSendClick !== '1') {
      btn.dataset.boundSendClick = '1';
      btn.addEventListener(
        'click',
        (e) => {
          const ok = validateOnSend();
          if (!ok) {
            e.preventDefault();
            e.stopPropagation();
            if (typeof e.stopImmediatePropagation === 'function') {
              e.stopImmediatePropagation();
            }
          }
        },
        true
      );
    }
  };

  /* =========================
     初期化
     ========================= */
  const init = () => {
    paintAsterisk();
    removePrivacyAsterisk();
    formatPrivacyInfoMessage();

    bindName();
    bindEmail();
    bindMessage();
    bindItemSelect();

    enableTextareaResize();

    bindPrivacy();
    bindSubmitValidation();

    // 位置固定（pの上）
    const root = scope();
    const wrap = root.querySelector('.terms_conditions');
    if (wrap) ensureWrapErrorEl(wrap, 'privacy');

    // ★セレクトのフォント強制（初期化のたびに戻す）
    forceItemSelectFont();
  };

  const boot = () => {
    init();
    setTimeout(init, 300);
    setTimeout(init, 900);
    setTimeout(init, 1800);

    let raf = 0;
    const mo = new MutationObserver(() => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => init());
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
